import React from "react";

interface PopUpHeaderProps {
  hideModal: (shouldClose: boolean) => void;
}

export const PopUpHeader = ({ hideModal }: PopUpHeaderProps) => (
  <div className="popup-modal__header">
    <button
      className="popup-modal__close"
      onClick={() => {
        hideModal(true);
      }}
    ></button>
  </div>
);
